export {
  COLORS,
  TYPOGRAPHY,
  SLOGAN,
  NAV_LINKS,
  SOCIAL_LINKS as BRAND_SOCIAL_LINKS,
} from "./brand";
export {
  SITE_URL,
  SITE_NAME,
  SITE_NAME_KO,
  SITE_TITLE,
  SITE_DESCRIPTION,
  SITE_TITLE_KO,
  SITE_DESCRIPTION_KO,
  SITE_KEYWORDS,
  FAQ_ENTRIES,
  CONTACT_EMAIL,
  STORE_URLS,
  SOCIAL_LINKS,
  OG_IMAGE_PATH,
  RELATED_SITES,
} from "./site";
export {
  zalandoFontCva,
  typographyCva,
  type ZalandoFontVariantProps,
  type TypographyVariantProps,
} from "./typography";
export {
  BLOG_LANGUAGE_NAMES,
  BLOG_LANGUAGES,
  linkableBlogLanguages,
  ORIGINAL_BLOG_LANGUAGE,
  parseBlogLanguage,
  toBlogLanguage,
  type BlogLanguage,
} from "./blogLanguages";
